import { render, staticRenderFns } from "./LoginAs.vue?vue&type=template&id=4450a85f&scoped=true"
import script from "./LoginAs.vue?vue&type=script&lang=js"
export * from "./LoginAs.vue?vue&type=script&lang=js"
import style0 from "./LoginAs.vue?vue&type=style&index=0&id=4450a85f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4450a85f",
  null
  
)

export default component.exports